import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { PaginationData } from "../../hooks/usePagination";

const Pagination = (props: { pagination: PaginationData; total: number }) => {
  const { pagination, total } = props;

  const first = (pagination.page - 1) * pagination.per + 1;
  const last = Math.min(first + pagination.per - 1, total);

  const showPrevious = pagination.page !== 1;
  const showNext = last !== total;

  if (total === 0) {
    return null;
  }

  return (
    <Wrapper>
      Showing {first} - {last} of {total}
      <div>
        <PaginationButton
          id="paginate-previous"
          disabled={!showPrevious}
          type="button"
          onClick={pagination.previous}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </PaginationButton>

        <PaginationButton
          id="paginate-next"
          disabled={!showNext}
          type="button"
          onClick={pagination.next}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </PaginationButton>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PaginationButton = styled.button`
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  padding: 0.25rem 0.75rem;
  border-radius: 3px;
  cursor: pointer;

  :disabled {
    color: #d1d5db;
    cursor: not-allowed;
  }

  :last-child {
    margin-left: 0.5rem;
  }
`;

export default Pagination;
